import React, { Component } from 'react'
import { reduxForm, Field, reset } from 'redux-form'
import emailValidator from 'email-validator'

import SettingsFormField from 'components/Shared/Forms/SettingsFormField'
import SettingsModalField from 'components/Shared/Forms/SettingsModalField'
import Button from 'components/Shared/Button'

const validate = ({ email }) => {
  const errors = {}

  if (email && !emailValidator.validate(email)) {
    errors.email = 'Please enter a valid email address'
  }

  return errors
}

class MembersForm extends Component {
  render() {
    const { handleSubmit, dirty, hasTeamSwitcher } = this.props

    const formFieldComponent = hasTeamSwitcher
      ? SettingsModalField
      : SettingsFormField

    return (
      <form onSubmit={handleSubmit} className="team-members-add-form">
        <Field
          inline
          small
          autoComplete="off"
          component={formFieldComponent}
          name="email"
          placeholder="Add member by email..."
        >
          <Button disabled={!dirty}>Invite</Button>
        </Field>
      </form>
    )
  }
}

const afterSubmit = (result, dispatch) => {
  dispatch(reset('addTeamMember'))
}

export default reduxForm({
  validate,
  form: 'addTeamMember',
  onSubmitSuccess: afterSubmit,
  enableReinitialize: true,
})(MembersForm)
